import { render, staticRenderFns } from "./orden_trabajo.vue?vue&type=template&id=1ce58355"
import script from "./orden_trabajo.vue?vue&type=script&lang=js"
export * from "./orden_trabajo.vue?vue&type=script&lang=js"
import style0 from "./orden_trabajo.vue?vue&type=style&index=0&id=1ce58355&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports